<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">


        <el-row :span="2" style="margin-top: 30px;">
            <el-select v-model="fenzu"  filterable placeholder="请选择" >
                <el-option
                  v-for="item in fenzuArr"
                  :key="item"
                  :label="item"

                  :value="item">
                </el-option>

            </el-select>
            <el-select v-model="seachLid"  filterable placeholder="请选择" >
                <el-option
                  v-for="item in options"
                  :key="item.label"
                  :label="item.label"

                  :value="item.value">
                </el-option>

              </el-select>
            <el-input v-model="seachName" style="width: 150px;" placeholder="请输入名称"></el-input>

            <el-button type="primary" style="background-color: #409eff;" @click="seach()" round>搜索</el-button>
        </el-row>
        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="500"
              label="指令"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.name}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="200"
              label="功能名称"
               >
               <template slot-scope="scope">
                 <div>{{scope.row.lidName}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="300"
              label="选组"
               >
               <template slot-scope="scope">
                   <div  @click="changexiaoguo(scope.row.type,scope.row.id)">{{scope.row.type}}</div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="删除"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id)">删除</el-col>
                   <!-- <el-col :span="4" style="text-align: center;margin-top: 15px;">更新</el-col> -->
                 </el-row>
               </template>
            </el-table-column>

            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>

    <el-dialog
      title="修改选组"
      :visible.sync="imgVisiblecxiaoguo"
      width="30%"
      center>
      <el-select v-model="xiaoguoc"   multiple placeholder="请选择" >
          <el-option
            v-for="item in xiaoguoArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="imgVisiblecxiaoguo = false">取 消</el-button>
    	<el-button type="primary" @click="dochangexiaoguo()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {
       return {
         page:1,
         count:0,
         list:[],
         value: '',
         name:'',
         options: [],
         seachName:'',
         seachLid:'',
         namenew:'',
         imgVisiblecxiaoguo:false,
         fenzuArr:['全部','通用','一','二','三','四','五','六','七','八','九','十','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'],
         xiaoguoArr:['通用','一','二','三','四','五','六','七','八','九','十','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30'],
         xiaoguoc:['通用'],
         xiaoguoc_id:0,
         fenzu:'全部'

      }
    },
  directives: {
    },
    created() {
      this.loadop();
      this.loadList();

    },

  methods:{
    changexiaoguo(xiaoguo,id){
      this.xiaoguoc_id = id
      this.xiaoguoc = xiaoguo.split(',')
      this.imgVisiblecxiaoguo = true
    },
    dochangexiaoguo(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:this.xiaoguoc_id,
          xiaoguo:this.xiaoguoc.join(','),
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/sduoweituijian'
      })
      .then(res=>{
        this.imgVisiblecxiaoguo = false
        this.xiaoguoc_id = 0
        this.xiaoguoc = ['通用']
      	this.loadList()

      })
      .catch(err=>{

      });
    },
    loadop(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{

    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/pythonImgList'
    	})
    	.then(res=>{
    		this.options = res.data;
        this.value = this.options[0]['value']

    	})
    	.catch(err=>{

    	});
    },
    seach(){
      this.loadList();
    },



    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,
          lid:this.seachLid,
          t:this.fenzu
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/qatdatalist'
      })
      .then(res=>{

        this.list = res.data.list;

        this.count = res.data.count;


      })
      .catch(err=>{

      });
    },

    del(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:id

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/qatDel'
      })
      .then(res=>{
      	this.$message({
      		type: 'success',
      		message: '删除成功'
      	});
        this.loadList();
      })
      .catch(err=>{

      });
    },



    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/main/qatdata.vue